import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ClerkProvider } from "@clerk/react";
import "./index.css";
import App from "./App.tsx";
import { COMMAND_ORIGIN, MARKETING_ORIGIN, hostMode } from "./lib/hosts";
import { commandClerkAppearance } from "./lib/clerkAppearance";

const publishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY as
  | string
  | undefined;

if (!publishableKey) {
  console.warn(
    "Missing VITE_CLERK_PUBLISHABLE_KEY — run `clerk env pull` or set site/.env.local"
  );
}

const mode = typeof window !== "undefined" ? hostMode() : "marketing";
const afterSignOut = mode === "command" ? MARKETING_ORIGIN : "/";

// OAuth/SSO must return to Command path routes (not marketing modal host).
// Same-origin relative paths on command; absolute Command URLs from marketing.
const commandSignIn = `${COMMAND_ORIGIN}/sign-in`;
const commandSignUp = `${COMMAND_ORIGIN}/sign-up`;
const commandHome =
  mode === "local" ? "/app" : mode === "command" ? "/" : `${COMMAND_ORIGIN}/`;

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    {publishableKey ? (
      <ClerkProvider
        publishableKey={publishableKey}
        appearance={commandClerkAppearance}
        afterSignOutUrl={afterSignOut}
        signInUrl={mode === "command" ? "/sign-in" : commandSignIn}
        signUpUrl={mode === "command" ? "/sign-up" : commandSignUp}
        signInFallbackRedirectUrl={commandHome}
        signUpFallbackRedirectUrl={commandHome}
        // Only force absolute Command home when auth starts off-command (marketing)
        {...(mode === "command" || mode === "local"
          ? {
              signInForceRedirectUrl: mode === "local" ? "/app" : "/",
              signUpForceRedirectUrl: mode === "local" ? "/app" : "/",
            }
          : {
              signInForceRedirectUrl: `${COMMAND_ORIGIN}/`,
              signUpForceRedirectUrl: `${COMMAND_ORIGIN}/`,
            })}
        // Stay on Command shell; OrgGate handles org pick (no /create-org bounce)
        taskUrls={{
          "choose-organization":
            mode === "command" ? "/" : `${COMMAND_ORIGIN}/`,
        }}
      >
        <App />
      </ClerkProvider>
    ) : (
      <App />
    )}
  </StrictMode>
);
